<template>
	<div class="pa-5 mt-5 content-pad-vert">
		<v-card class="pa-5">
			<v-card-text>
				{{ msg }}
				<br><br>
				<v-btn
					dark
					large
					class="btn-blue"
					v-if="confirmed"
					to="/"
				>
					Go home
				</v-btn>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'confirm-email',
	data() {
		return {
			confirmed: false,
			msg: 'Confirming...'
		}
	},
	created() {
		console.log(this.$route.params.code)
		axios
			.post('/rest-auth/registration/verify-email/', {
				key: this.$route.params.code
			})
			.then(response => {
				console.log(response)
				this.confirmed = true
				this.msg = 'Thank you for confirming your email!'
			})
			.catch(error => {
				console.error(error)
			})
	}
}
</script>
